import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ContactBanner = styled.div`
  background: #7F1B1C;
  padding: 2rem;
  margin-top: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20rem;
  text-align: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
    padding: 1.5rem;
  }
`;

const BannerText = styled.h3`
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const ContactButton = styled.button`
  background: linear-gradient(135deg, #2d1b1b 0%, #FF0707 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 7, 7, 0.3);
  }
`;

const KPCardContact = () => {
  return (
    <ContactBanner
      as={motion.div}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <BannerText>
        Get your KP Card today
      </BannerText>
      <ContactButton>
        Contact us
      </ContactButton>
    </ContactBanner>
  );
};

export default KPCardContact; 